// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"30f73249b8b49d925ec2","339":"854ed7ca7362e2d6012d"}[chunkId] + ".js";
};